import { Button } from '@material-ui/core';
import { KeyboardArrowRight } from '@material-ui/icons';
import Connector from 'connect-store';
import * as React from 'react';
import { fetchConstants } from './api/constant/constant';
import mapStore from './storeInstances/mapStore';
import LayerOptionStore from './stores/LayerOptionStore/LayerOptionStore';
import GraphInfoPanelView from './views/graphInfoPanelView/GraphInfoPanelView';
import LayerPanelView from './views/layerPanelView/LayerPanelView';
import MapView from './views/MapView';

export default class App extends React.Component {

  public state = {
    isLayerNavShow: true,
    loading: true,
  };

  public componentDidMount() {
    (async () => {
      const { data } = await fetchConstants();
      (window as any).constants = data;
      this.setState({ loading: false });
    })().catch(() => this.setState({ loading: false }));
  }

  public render() {
    // const { isLayerNavShow } = this.state;
    const { loading } = this.state;
    if (loading) {
      return <div style={{ width: '100%', marginTop: '20px', textAlign: 'center' }}>正在加载...</div>;
    } else {
      return (
        <div style={{ width: '100%', height: '100%', display: 'flex', position: 'relative' }}>
          {/*<Button*/}
          {/*size={'small'}*/}
          {/*style={{*/}
          {/*position: 'absolute',*/}
          {/*top: 40,*/}
          {/*background: 'white',*/}
          {/*left: isLayerNavShow ? 305 : 0,*/}
          {/*zIndex: 100,*/}
          {/*}}*/}
          {/*onClick={() => this.setState({ isLayerNavShow: !isLayerNavShow })}*/}
          {/*>*/}
          {/*{isLayerNavShow ? '隐藏' : '展开'}*/}
          {/*</Button*/}
          {/*>*/}
          <Connector
            View={LayerPanelView}
            store={[mapStore, new LayerOptionStore()]}
          />
          {/*<Connector*/}
            {/*View={GraphInfoPanelView}*/}
            {/*store={mapStore}*/}
          {/*/>*/}
          <Connector
            View={MapView}
            store={mapStore}
          />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/App.tsx